import { styled } from "@mui/material";
import Component from "./component";

export default styled(Component)(() => ({
  display: "grid",
  gridTemplateColumns: "repeat(2, 1fr)",
  width: "50%",
  maxWidth: 800,
  // flexDirection: "column",
  margin: "0 auto",
  justifyContent: "center",
  gap: "1rem",

  "& .MuiTextField-root": {
    margin: 8,
  },
}));
